export default (context) => {
    let obj = context.main[context.main.length - 1]
    if((obj ? obj.type : false) === 'text') {
        context.overlay = true
        context.popup.value = true
        context.popup.text = `Нежелательно добавлять несколько текстовых блоков подряд,
                        получится не очень.`
        context.popup.hint = `Попробуйте добавить видео.`
    } else if(context.main.length === 0) {
        context.overlay = true
        context.popup.value = true
        context.popup.text = `Нежелательно добавлять текст после вступительного ролика.`
        context.popup.hint = `Попробуйте добавить видео.`
    } else {
        context.$router.push('/add-text')
    }
}